import { css } from '@linaria/core';
import { Tab } from '@headlessui/react';
import { FC, Fragment } from 'react';
import { ChatUI } from 'modules/Playground/Components/ChatUI';
import { ApiUI } from 'modules/Playground/Components/ApiUI';
import { PlaygroundChatConfigSidebar } from 'modules/Playground/Components/PlaygroundChatConfigSidebar';
import { PlaygroundContentHeader } from 'modules/Playground/Components/PlaygroundContentHeader/PlaygroundContentHeader';
import { useDataCollection } from 'modules/AnalyticsCollection/AnalyticsCollectionProvider';
import { breakpoints } from 'styles/utils';
import { useField } from 'formik';
import { useIsPlaygroundCompatibleModel } from './TabButtons/useIsPlaygroundCompatibleModel';
import { PlaygroundConfig } from '../types/playgroundConfig';
import { useCompareMode } from '../hooks/utils/useCompareMode';
export const PlaygroundChatSection: FC = () => {
  const {
    track
  } = useDataCollection();
  const isModelCompatible = useIsPlaygroundCompatibleModel();
  const [{
    value: model
  }] = useField<PlaygroundConfig['model']>('model');
  const {
    isCompareMode
  } = useCompareMode();
  return <div className={PlaygroundContentContainer}>
      <div className={playgroundContentSection}>
        <div className={playgroundContentMain}>
          <Tab.Group onChange={tabId => {
          track(`Playground -> Tab Changed ${tabId === 0 ? 'UI' : 'API'}`);
        }}>
            <PlaygroundContentHeader />
            <div className={playgroundContentModelSection}>
              <Tab.Panels as={Fragment}>
                {isModelCompatible ? <Tab.Panel unmount={false} className={TabPanelContainer}>
                    <ChatUI />
                  </Tab.Panel> : null}
                <Tab.Panel unmount={false} className={TabPanelContainer}>
                  <ApiUI key={model?.id} />
                </Tab.Panel>
              </Tab.Panels>
            </div>
          </Tab.Group>
        </div>
        {!isCompareMode && <PlaygroundChatConfigSidebar />}
      </div>
    </div>;
};
const PlaygroundContentContainer = "odules__Playground__Components__PlaygroundChatSection_tsx-PlaygroundContentContainer-p1axxllz";
const playgroundContentSection = "odules__Playground__Components__PlaygroundChatSection_tsx-playgroundContentSection-pespyj1";
const playgroundContentMain = "odules__Playground__Components__PlaygroundChatSection_tsx-playgroundContentMain-prfma9s";
const playgroundContentModelSection = "odules__Playground__Components__PlaygroundChatSection_tsx-playgroundContentModelSection-pmz4j8i";
const TabPanelContainer = "odules__Playground__Components__PlaygroundChatSection_tsx-TabPanelContainer-t1hnti49";

require("./PlaygroundChatSection.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./PlaygroundChatSection.tsx");